import { useQuery } from "@tanstack/react-query"

import type { KarmaConfig } from "@/governance/helpers/karma"
import { fetchKarmaStats } from "@/governance/helpers/karma"

export const useKarmaStats = ({
  address,
  config = {},
  karmaName,
}: {
  address?: string
  config?: KarmaConfig
  karmaName?: string
}) => {
  const lowercaseAddress = address?.toLowerCase()

  return useQuery({
    queryKey: ["karma-score", karmaName, lowercaseAddress],
    queryFn: async () => {
      return await fetchKarmaStats(karmaName, address, config)
    },
    enabled: !!address && !!karmaName,
  })
}
